@if (bannerVisible()) {
  <lib-cookie-consent-banner
    (acceptAll)="onAcceptAll()"
    (rejectAll)="onRejectAll()" />
}
@if (preferencesOpen()) {
  <lib-cookie-consent-preferences-dialog
    [value]="current()"
    (save)="record($event)"
    (closed)="closePreferences()" />
}
